import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { RnBreadcrumb } from "../components/RnBreadcrumb";
import { RnExplainer } from "../components/RnExplainer";
import { RomanTool } from "../components/RomanTool";

export function RomanNumeralPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <RnBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.rn_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.rn_intro()}
          </p>
        </header>

        <RomanTool />

        <RnExplainer
          howTo={m.rn_howto()}
          faqs={[
            { q: m.rn_faq1_q(), a: m.rn_faq1_a() },
            { q: m.rn_faq2_q(), a: m.rn_faq2_a() },
            { q: m.rn_faq3_q(), a: m.rn_faq3_a() },
            { q: m.rn_faq4_q(), a: m.rn_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
